module.exports = __webpack_public_path__ + "components/rewards/armadillo/static/logo-d0ea8682de23beca6da709718f392890.webp";